import React, { useEffect, useState } from 'react';
import { Grid, Box, Button, CircularProgress, Typography } from '@mui/material';
import SalesPageGraphs from './SalesPageGraphs';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft } from 'lucide-react';

function TodaysGraphsPage() {
  const [todaysSales, setTodaysSales] = useState([]);
  const [ordersToday, setOrdersToday] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get('https://shopify-inv-tracker-backend-d0b1c1125141.herokuapp.com/api/todays-sales')
      .then((response) => {
        setTodaysSales(response.data.salesData || []);
        setOrdersToday(response.data.ordersToday || []);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching today's sales:", error);
        setError('Failed to fetch data. Please try again later.');
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" sx={{ height: '60vh' }}>
        <CircularProgress size={32} thickness={3} />
      </Box>
    );
  }

  if (error) {
    return (
      <Box className="fade-in" sx={{ textAlign: 'center', py: 6 }}>
        <Typography variant="body2" color="error" sx={{ mb: 2 }}>{error}</Typography>
        <Button onClick={() => navigate('/')} startIcon={<ArrowLeft size={16} />}>Back to Dashboard</Button>
      </Box>
    );
  }

  if (todaysSales.length === 0 && ordersToday.length === 0) {
    return (
      <Box className="fade-in" sx={{ textAlign: 'center', py: 6 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>No sales or orders available for today.</Typography>
        <Button onClick={() => navigate('/')} startIcon={<ArrowLeft size={16} />}>Back to Dashboard</Button>
      </Box>
    );
  }

  return (
    <Box className="fade-in">
      <Button onClick={() => navigate('/')} startIcon={<ArrowLeft size={16} />} sx={{ mb: 2, color: 'text.secondary', fontWeight: 500 }}>
        Back to Dashboard
      </Button>

      <Typography variant="h4" sx={{ fontWeight: 700, letterSpacing: '-0.02em', mb: 3 }}>
        Sales Graphs
      </Typography>

      <Grid container spacing={2}>
        {todaysSales.map((product) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={product.shopifyId}>
            <Box sx={{
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 2,
              p: 2,
              transition: 'all 0.12s',
              '&:hover': { borderColor: 'primary.main', transform: 'translateY(-2px)' },
            }}>
              <SalesPageGraphs productId={product.shopifyId} quantitySoldToday={product.quantity} />
              <Typography variant="caption" sx={{ display: 'block', mt: 1, color: 'text.secondary', fontWeight: 500 }}>
                {product.title}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default TodaysGraphsPage;
